"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagHalf = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var FlagHalf = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M20.6 4.8h-7.8a2.4 2.4 0 00-2.4-2.4h-6V.6a.6.6 0 00-.6-.6H2.6a.6.6 0 00-.6.6v22.8a.6.6 0 00.6.6h1.2a.6.6 0 00.6-.6v-9h6a2.4 2.4 0 002.4 2.4h7.8a.6.6 0 00.6-.6V5.4a.6.6 0 00-.6-.6zm-7.8 2.4h6v7.2h-6V7.2z" })); };
exports.FlagHalf = FlagHalf;
//# sourceMappingURL=flag-half.js.map